export const ABOVE_GLASS = 'aboveGlass';
export const PRIMARY_GLASS = 'primaryGlass';
export const SECONDARY_GLASS = 'secondaryGlass';
export const SIDE_GLASS_LEFT = 'sideGlassLeft';
export const SIDE_GLASS_RIGHT = 'sideGlassRight';

export default [
  ABOVE_GLASS,
  PRIMARY_GLASS,
  SECONDARY_GLASS,
  SIDE_GLASS_LEFT,
  SIDE_GLASS_RIGHT,
];
